import { createSelector } from '@ngrx/store';

import { RootState } from '@store/index';
import { RouterSelectors } from '../router';

import { HttpHelper } from '@lib/utils';
import { cloneDeep } from 'lodash-es';

export namespace CmsPageSelectors {
  export const selectCmsPagesState = (state: RootState) => state.cmsPages;

  export const selectCurrentCmsPage = createSelector(RouterSelectors.selectRouterUrl, selectCmsPagesState, (url, state) => {
    // Root urls are defined as '/en/home' and '/de/home' in CMS
    if (HttpHelper.isRootPath(url)) {
      url = url.endsWith('/') ? url.slice(0, -1) : url;
      url += '/home';
    }

    const encodedUrl = btoa(url);
    const entity = state.entities[encodedUrl];

    return entity ? cloneDeep(entity) : null;
  });
}
